const Enum = require('@barchart/common-js/lang/Enum');

module.exports = (() => {
	'use strict';

	/**
	 * Classifies a "remote" address.
	 *
	 * @public
	 * @extends {Enum}
	 * @param {String} code
	 */
	class RemoteType extends Enum {
		constructor(code, validator, formatter) {
			super(code, code);
		}

		/**
		 * Returns the {@link RemoteType} associated with a specific code.
		 *
		 * @public
		 * @static
		 * @param {String} code
		 * @returns {RemoteType|null}
		 */
		static parse(code) {
			return Enum.fromCode(RemoteType, code);
		}

		/**
		 * An email address.
		 *
		 * @public
		 * @static
		 * @returns {RemoteType}
		 */
		static get EMAIL_ADDRESS() {
			return email;
		}

		/**
		 * A phone number.
		 *
		 * @public
		 * @static
		 * @returns {RemoteType}
		 */
		static get PHONE_NUMBER() {
			return phone;
		}

		toString() {
			return `[RemoteType (code=${this.code})]`;
		}
	}

	const email = new RemoteType('EMAIL_ADDRESS');
	const phone = new RemoteType('PHONE_NUMBER');

	return RemoteType;
})();
